import React from 'react';
import { Result, Button } from 'antd';
import { ReloadOutlined, HomeOutlined } from '@ant-design/icons';

const ErrorBoundary = ({ error, resetError, children }) => {
  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '50vh',
        padding: '20px'
      }}>
        <Result
          status="error"
          title="系统出现异常"
          subTitle="抱歉，数字人系统遇到了一些问题，请稍后重试。"
          extra={[
            <Button type="primary" key="retry" icon={<ReloadOutlined />} onClick={resetError}>
              重新加载
            </Button>,
            <Button key="home" icon={<HomeOutlined />} onClick={() => window.location.reload()}>
              刷新页面
            </Button>,
          ]}
        >
          <div style={{ 
            background: '#fafafa', 
            padding: '16px', 
            borderRadius: '8px',
            marginTop: '16px'
          }}>
            <p><strong>如果问题持续存在，请联系技术支持：</strong></p>
            <p>📧 邮箱：support@DSmilife.com</p>
            <p>📞 电话：400-123-4567</p>
          </div>
        </Result>
      </div>
    );
  }

  return children;
};

export default ErrorBoundary;
